import type { AIMessageDraft } from 'bundles/enterprise-admin-messaging-v2/components/AIMessageModal/types';

/**
 * Stand-in for the real "upload audience CSV" backend call. Resolves an
 * uploaded file name to a parsed audience (learner count + summary) so the
 * manual-draft screen can show the audience chip without a real upload. The
 * count is canned; only the file name reflects the actual selected file.
 *
 * Replace the entire function with the real CSV-upload GraphQL mutation once
 * the backend ships — the call site (and the draft fields it writes) stay the
 * same.
 */
export const mockUploadCsv = (
  fileName: string
): Pick<AIMessageDraft, 'audienceFileName' | 'audienceCount' | 'audienceSummary'> => ({
  audienceFileName: fileName,
  audienceCount: 150,
  audienceSummary: '150 learners',
});
